import ActionTypes from '../../ActionsTypes';
export function saveCountryData(id, data) {
  return {
    type: ActionTypes.SAVE_COUNTRY_DATA,
    payload: {
      id: id,
      data: data
    }
  };
}